import React, { useState } from 'react';
import { Bold, Italic, List, Link as LinkIcon, ChevronDown, Eye } from 'lucide-react';
interface EmailStepEditorProps {
  subject: string;
  body: string;
  onUpdate: (data: {
    subject: string;
    body: string;
  }) => void;
}
const EmailStepEditor: React.FC<EmailStepEditorProps> = ({
  subject,
  body,
  onUpdate
}) => {
  const [currentSubject, setCurrentSubject] = useState(subject);
  const [currentBody, setCurrentBody] = useState(body);
  const [previewMode, setPreviewMode] = useState(false);
  const handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentSubject(e.target.value);
    onUpdate({
      subject: e.target.value,
      body: currentBody
    });
  };
  const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentBody(e.target.value);
    onUpdate({
      subject: currentSubject,
      body: e.target.value
    });
  };
  return <div className="space-y-4" data-id="element-215">
      <div className="flex justify-between items-center" data-id="element-216">
        <h3 className="text-lg font-medium" data-id="element-217">Email Configuration</h3>
        <div className="flex items-center gap-2" data-id="element-218">
          <button className={`px-3 py-1 rounded-md text-sm ${!previewMode ? 'bg-blue-100 text-blue-800' : 'bg-gray-200'}`} onClick={() => setPreviewMode(false)} data-id="element-219">
            Edit
          </button>
          <button className={`px-3 py-1 rounded-md text-sm ${previewMode ? 'bg-blue-100 text-blue-800' : 'bg-gray-200'}`} onClick={() => setPreviewMode(true)} data-id="element-220">
            <Eye size={14} className="inline mr-1" data-id="element-221" /> Preview
          </button>
        </div>
      </div>
      {!previewMode ? <>
          <div data-id="element-222">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-223">
              Subject
            </label>
            <input type="text" value={currentSubject} onChange={handleSubjectChange} className="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Email subject" data-id="element-224" />
          </div>
          <div data-id="element-225">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-226">
              Email Body
            </label>
            <div className="border border-gray-300 rounded-md" data-id="element-227">
              <div className="flex items-center gap-1 px-2 py-1 border-b bg-gray-50" data-id="element-228">
                <button className="p-1 hover:bg-gray-200 rounded" data-id="element-229">
                  <Bold size={16} data-id="element-230" />
                </button>
                <button className="p-1 hover:bg-gray-200 rounded" data-id="element-231">
                  <Italic size={16} data-id="element-232" />
                </button>
                <button className="p-1 hover:bg-gray-200 rounded" data-id="element-233">
                  <List size={16} data-id="element-234" />
                </button>
                <button className="p-1 hover:bg-gray-200 rounded" data-id="element-235">
                  <LinkIcon size={16} data-id="element-236" />
                </button>
                <div className="h-4 border-r border-gray-300 mx-1" data-id="element-237"></div>
                <button className="flex items-center gap-1 px-2 py-1 text-sm border rounded hover:bg-gray-200" data-id="element-238">
                  Insert Variable <ChevronDown size={14} data-id="element-239" />
                </button>
              </div>
              <textarea value={currentBody} onChange={handleBodyChange} className="w-full px-3 py-2 min-h-[300px] focus:outline-none" placeholder="Write your email content here..." data-id="element-240" />
            </div>
          </div>
        </> : <div className="border rounded-md p-5 bg-gray-50 min-h-[400px]" data-id="element-241">
          <div className="bg-white rounded-md border p-4" data-id="element-242">
            <div className="border-b pb-2 mb-3" data-id="element-243">
              <div className="font-medium" data-id="element-244">Subject: {currentSubject}</div>
              <div className="text-sm text-gray-500" data-id="element-245">
                From: {'{{Account.Owner}}'} &lt;{'{{Account.Owner.Email}}'}&gt;
              </div>
              <div className="text-sm text-gray-500" data-id="element-246">
                To: {'{{Contact.Email}}'}
              </div>
            </div>
            <div className="whitespace-pre-wrap" data-id="element-247">{currentBody}</div>
          </div>
        </div>}
    </div>;
};
export default EmailStepEditor;